export default __webpack_public_path__ + "static/media/a011-7.fd8932f9.svg";